import { toast } from 'sonner';
import { saveToCsv } from './save-to-csv';

const CSV_EXPORT_SUCCESS_MESSAGE = 'CSV exported successfully';

export function saveToCsvWithSuccessToast(
    content: (string | number)[][],
    filename: string,
    message: string = CSV_EXPORT_SUCCESS_MESSAGE,
) {
    saveToCsv(content, filename);
    toast.success(message);
}
